/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:36:55+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-23T16:41:16+08:00
 */
 import keyMirror from "keymirror";

 export const EmployeeManagement = {
   ActionTypes: keyMirror({
     FETCHDATA: null,
     FETCHALLSUCCESS: null,
     FETCHEMPLOYEEGROUPDATA:null,
     FETCHEMPLOYEEUSERDATA:null,
     FETCHSUCCESS: null,
     FETCHFAILURE: null,
     CREATESUCCESS: null,
     CREATEFAILURE: null,
     UPDATESUCCESS: null,
     UPDATEFAILURE: null,
     DELETESUCCESS: null,
     DELETEFAILURE: null,
     EMPTY: null,
     FETCHEXPORTCOLUMNSUCCESS: null,
     FETCHEXPORTCOLUMNFAILURE: null,
     EXPORTEMPLOYEESSUCCESS: null,
     EXPORTEMPLOYEESFAILURE: null,
     // 合同管理
     FETCHCONTRACTLISTSUCCESS: null,
     // FETCHCONTRACTEMPLOYEESUCCESS:null,
     FETCHCONTRACTDETAILSUCCESS: null,
     INITCONTRACTALERTSUCCESS: null,
     CHANGECONTRACTOVERALERT: null,
     CHANGECONTRACTPROBATIONOVERALERT: null,
     NEWCONTRACT: null,
     DELETECONTRACT: null,
     ADDCONTRACTSUCCESS: null,
     CHANGECONTRACT: null,
     EDITCONTRACTSUCCESS: null,

     // 证件管理 created by zangkang
     FETCHCERTIFICATELISTSUCCESS: null,
     FETCHCERTIFICATEEMPLOYEELISTSUCCESS:null,
     FETCHCERTIFICATELISTFAILURE: null,
     CREATECERTIFICATESUCCESS: null,
     CREATECERTIFICATEFAILURE: null,
     UPDATECERTIFICATESUCCESS: null,
     UPDATECERTIFICATEFAILURE: null,
     TOGGLEEDITCONTRACT: null,
     RECOVERCONCTRACT: null,
     CHANGECERTIFICATEVALUE: null,

     // 通讯录 created by zangkang
     FETCHADDRESSDATA: null,
     FEACHADDRESSSUCCESS: null,
     FETCHADDRESSFAILURE: null,
     EXPORTADDRESSLISTFAILURE: null,

     // 生日名单
     FETCHSTAFFBIRTHDAYLISTSUCCESS: null,
     FETCHSTAFFBIRTHDAYLISTFAILURE: null,
     EXPORTSTAFFBIRTHDAYLISTSUCCESS: null,
     EXPORTSTAFFBIRTHDAYLISTFAILURE: null,
     FETCHSTAFFBIRTHDAYDETAILSUCCESS: null,
     FETCHSTAFFBIRTHDAYDETAILFAILURE: null,
     //月度报表

     //机票、住房
     FETCHAIRTICKETSUBSIDYLISTSUCCESS:null,
     FETCHHOUSINGALLOWANCELISTSUCCESS:null,

     //合同管理中获取合同到期前接收提醒人员列表
     FETCHCONTRACTRECEIVEEXPIREMEMBERSUSSESS:null,
     FETCHCONTRACTRECEIVEEXPIREMEMBEFAILURE:null,


   })
 };



// WEBPACK FOOTER //
// ./src/constants/employee-management-constants.js